import { resetLuckySpin } from '@/lib/store/lucky-spin/actions';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import LuckySpinBanner from '../Banner';
import LuckySpinHeader from '../Header';
import LuckySpinRoulette from '../Roulette';
import RouletteButton from '../Roulette/Button';
import LuckySpinWonBanner from '../WonBanner';
import styles from '../styles.module.scss';
export default function LuckySpinContent() {
  const dispatch = useDispatch();

  function unmountHandler() {
    return () => {
      dispatch(resetLuckySpin());
    };
  }

  useEffect(unmountHandler, [dispatch]);

  return (
    <div className={styles.container}>
      <LuckySpinHeader />
      <LuckySpinRoulette />
      <LuckySpinBanner />
      <RouletteButton />
      <LuckySpinWonBanner />
    </div>
  );
}
